import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// SPPO AMEND (CREATION SIDE) APIs
// Legacy route: /Purchase/SPPOAmend
// Note: spPoAmendAPI.js in this same folder backs the *verification* page
// (VerifySPPOAmend.jsx) and is registered under the "sppoAmend" store key —
// this file is the creation-side counterpart and its slice uses a different
// store key ("sppoAmendCreation") to avoid clobbering it.
// ==============================================

const get = async (path, params, errMsg) => {
    try {
        const queryParams = new URLSearchParams(params || {});
        const qs = queryParams.toString();
        const response = await axios.get(
            `${API_BASE_URL}${path}${qs ? `?${qs}` : ''}`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error(`❌ ${errMsg}:`, error.response || error);
        if (error.response?.data) throw error.response.data;
        throw error;
    }
};

const post = async (path, body, errMsg) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}${path}`,
            body,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error(`❌ ${errMsg}:`, error.response || error);
        if (error.response?.data) throw error.response.data;
        throw error;
    }
};

export const getVendorsForSPPOAmend = () =>
    get('/Purchase/GetVendorsForSPPOAmend', {}, 'Get Vendors For SPPO Amend API Error');

export const getCCForSPPOAmendByVendor = (vendorCode) =>
    get('/Purchase/GetCCForSPPOAmendbyVendor', { VendorCode: vendorCode }, 'Get CC For SPPO Amend API Error');

export const getPOForSPPOAmend = (vendorCode, ccCode) =>
    get('/Purchase/GetPOForSPPOAmend', { VendorCode: vendorCode, CCCode: ccCode }, 'Get PO For SPPO Amend API Error');

export const getSPPOByNoForAmend = (sppono, ccCode, vendorCode) =>
    get('/Purchase/GetSPPObyNoForAmend', { Sppono: sppono, CCCode: ccCode, VendorCode: vendorCode }, 'Get SPPO By No For Amend API Error');

export const getUploadDocSPPOAmendValue = (ccCode) =>
    get('/Purchase/UpdloadDocSPPOAmendValue', { CCCode: ccCode }, 'Get Upload Doc SPPO Amend Value API Error');

export const checkSPPOAmendDescriptions = (payload) =>
    post('/Purchase/CheckSPPOAmendDescriptions', payload, 'Check SPPO Amend Descriptions API Error');

export const saveNewSPPOAmend = (payload) =>
    post('/Purchase/SaveNewSPPOAmend', payload, 'Save New SPPO Amend API Error');
